import React, { useState } from "react";
import { motion } from "framer-motion";
import { FileText, Download, Filter, Calendar } from "lucide-react";

const CustomReportsPage = () => {
  const [reportType, setReportType] = useState("student");

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <motion.div
        className="max-w-7xl mx-auto space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="p-3 bg-gradient-to-br from-pink-600 to-rose-600 rounded-2xl shadow-lg shadow-pink-500/20">
            <FileText className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-br from-pink-400 to-rose-400 bg-clip-text text-transparent">
            Custom Reports
          </h1>
        </div>

        {/* Generator Form */}
        <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
          <h2 className="text-xl font-semibold text-white mb-6">
            Generate New Report
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <div>
              <label className="block text-gray-400 text-sm mb-2">
                Report Type
              </label>
              <select
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                className="w-full bg-gray-900 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-pink-500"
              >
                <option value="student">Student Details</option>
                <option value="performance">Academic Performance</option>
                <option value="attendance">Attendance Records</option>
                <option value="fee">Fee Collections</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-400 text-sm mb-2">
                Date Range
              </label>
              <div className="flex gap-2">
                <input
                  type="date"
                  className="w-full bg-gray-900 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-pink-500"
                />
                <input
                  type="date"
                  className="w-full bg-gray-900 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-pink-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-400 text-sm mb-2">
                Batch / Course
              </label>
              <select className="w-full bg-gray-900 border border-gray-700 rounded-lg p-3 text-white focus:outline-none focus:border-pink-500">
                <option>All Batches</option>
                <option>Batch A</option>
                <option>Batch B</option>
              </select>
            </div>
          </div>

          <div className="flex flex-wrap gap-4 border-t border-gray-700 pt-6">
            <div className="flex-1">
              <label className="block text-gray-400 text-sm mb-3">
                Include Fields
              </label>
              <div className="flex flex-wrap gap-3">
                {[
                  "Name",
                  "Enrollment No",
                  "Phone",
                  "Email",
                  "Address",
                  "Status",
                ].map((field) => (
                  <label
                    key={field}
                    className="flex items-center gap-2 bg-gray-900 px-3 py-2 rounded-lg cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      defaultChecked
                      className="rounded border-gray-600 bg-gray-800 text-pink-500 focus:ring-pink-500"
                    />
                    <span className="text-gray-300 text-sm">{field}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-8">
            <button className="px-6 py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors">
              Preview
            </button>
            <button className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-600 to-rose-600 text-white rounded-lg hover:shadow-lg hover:shadow-pink-500/20 transition-all font-semibold">
              <Download className="w-5 h-5" />
              Download Report
            </button>
          </div>
        </div>

        {/* Recent Reports */}
        <div className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden">
          <div className="p-4 border-b border-gray-700 bg-gray-800/50">
            <h3 className="font-semibold text-gray-300">Recently Generated</h3>
          </div>
          <table className="w-full text-left">
            <tbody className="divide-y divide-gray-700">
              {[1, 2, 3].map((i) => (
                <tr key={i} className="hover:bg-gray-700/30 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <FileText className="w-5 h-5 text-gray-500" />
                      <span className="text-white">
                        Monthly Attendance Report - Batch A
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-gray-400 text-sm">
                    Generated on 12 Dec, 2023
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-blue-400 hover:text-blue-300 text-sm font-medium">
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default CustomReportsPage;
